import React from 'react';
import { WidgetWrapper } from './HBSideNavWidget.styles';
import { HBSideNavWidgetProps } from './HBSideNavWidget.types';

export const HBSideNavWidget: React.FC<HBSideNavWidgetProps> = ({
    onClick,
    className,
    testId,
    children
}) => {
    return (
        <WidgetWrapper
            onClick={onClick}
            className={className}
            data-testid={testId}
        >
            {children}
        </WidgetWrapper>
    );
};
